import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Breadcrumbs, Button } from "@unified-checkout/design-system";
import type {
  IUserManagementHeader
} from "@app/dashboard/types/innerLayout/user_management/header";
import styles from "./header.module.scss";

export const Header = ({
  breadcrumbs,
  title,
  hint,
  actionBtns
}: IUserManagementHeader
) => {
  const location = useLocation();
  const [rerenderKey, setRerenderKey] = useState(0);

  useEffect(() => {
    setRerenderKey((prevKey) => prevKey + 1);
  }, [location]);

  return (
    <div className={styles["header"]}>

      {
        breadcrumbs &&
        <div className={styles["header__breadcrumbs"]}>
          <Breadcrumbs {...breadcrumbs} />
        </div>
      }

      {
        (title || hint) &&
        <div className={styles["header__text-box"]}>
          {
            title &&
            <div className={styles["header__text-box__title"]}>
              {title}
            </div>
          }
          {
            hint &&
            <div className={styles["header__text-box__hint"]}>
              {hint}
            </div>
          }
        </div>
      }

      {
        actionBtns &&
        <div className={styles["header__action-btns"]}>
          {
            actionBtns.map((btn, i) =>
              <Button
                key={`${rerenderKey}-user-management-header-action-${i}`}
                {...btn}
              />
            )
          }
        </div>
      }

    </div>
  )
}
